import React, { useEffect, useMemo, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Grid,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
  InputAdornment,
  Card,
  Typography,
  MenuItem,
} from "@mui/material";
import {
  useDeleteOrderListHistoryMutation,
  useGetOrderListQuery,
  useAdminChangeStatusMutation,
  useChangeStatusOrderListSentToManagerMutation,
  useGetUserInfoOnyQuery,
  useGetAllAdminOrderListQuery,
  useGetRestaurantQuery,
} from "../../../Api/attoDeskApi";
import {
  IOrderList,
  IUserAdmin,
  IRestaurant,
} from "../../../Api/Interface/api.interface";
// import NewPopUpTeam from "../Edit/index";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import { useNotifier } from "../../../Core/Notifier";
import { CiSearch } from "react-icons/ci";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import "jspdf-autotable";
import dayjs, { Dayjs } from "dayjs";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import StatusPopup from "../../../Components/Delete/StatusPopup";
import useUser from "../../../Core/hook/useUser";
import {
  OrderListStatus,
  OrderListStatusList,
  Privileges,
} from "../../../Core/Enum/enum";
import Pagination from "../../../Components/Pagination";
import { useFormik } from "formik";
import ChecklistRtlRoundedIcon from "@mui/icons-material/ChecklistRtlRounded";
import useIsMobile from "../../../Core/hook/useIsMobile";

const convertStatus = (unit: string): string => {
  switch (unit) {
    case "OrderListCreated":
      return "Created";
    case "SentToManager":
      return "SentToManager";
    case "ManagerApproved":
      return "Approved";
    case "UpdatedPrice":
      return "Updated Price";
    // case "ManagerConfirmed":
    //   return "Confirmed";
    case "Processed":
      return "Processed";
    case "Completed":
      return "Completed";
    case "Rejected":
      return "Rejected";
    case "ReceiptUpdated":
      return "Receipt Updated";
    default:
      return "";
  }
};

const convertStatus2 = (unit: string): string => {
  switch (unit) {
    case "OrderListCreated":
      return "Order List Created";
    case "SentToManager":
      return "Sent To Manager";
    case "ManagerApproved":
      return "Approved";
    case "UpdatedPrice":
      return "Updated Price";
    // case "ManagerConfirmed":
    //   return "Confirmed";
    case "Processed":
      return "Processed";
    case "Completed":
      return "Completed";
    case "Rejected":
      return "Rejected";
    default:
      return "";
  }
};

const Index = () => {
  const classes = useStyles();
  const isMobileRes = useIsMobile();
  const navigate = useNavigate();
  const { userHasRight } = useUser();
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [searchQuerySentToManager, setSearchQuerySentToManager] = useState("");
  const [currentSearchQuerySentToManager, setCurrentSearchQuerySentToManager] =
    useState("");
  const [pageSentToManager, setPageSentToManager] = useState(0);
  const [rowsPerPageSentToManager, setRowsPerPageSentToManager] = useState(10);
  const [selectedCoursing, setSelectedCoursing] = useState<IOrderList | null>(
    null
  );
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const debouncedSearchQuerySentToManager = useDebounce(
    searchQuerySentToManager,
    300
  );

  const [openDialog, setOpenDialog] = useState(false);
  const [openDeleteCategory, setOpenDeleteCategory] = useState(false);
  const [coursingToDelete, setCoursingToDelete] = useState<IOrderList | null>(
    null
  );
  const [coursingToStatus, setCoursingToStatus] = useState<IOrderList | null>(
    null
  );
  const [open, setOpen] = useState(false);
  const [openOrderListDate, setOpenOrderListDate] = useState(false);
  const [coursingToStatus2, setCoursingToStatus2] = useState<IOrderList | null>(
    null
  );
  const [selectedIsAllStatus, setSelectedProductIsAllStatus] =
    useState<string>("AllStatus");
  const { data, isLoading, isError, refetch } = useGetOrderListQuery({
    searchText: currentSearchQuery,
    orderListStatus: "OrderListCreated",
    id: "",
  });

  const {
    data: SentToManagerData,
    isLoading: SentToManagerIsLoading,
    isError: SentToManagerIsError,
  } = useGetAllAdminOrderListQuery({
    searchText: currentSearchQuerySentToManager,
    orderListStatus:
      selectedIsAllStatus && selectedIsAllStatus !== "AllStatus"
        ? selectedIsAllStatus
        : "",
    id: "",
  });

  const { data: userData, isLoading: userIsLoading } = useGetUserInfoOnyQuery({
    searchText: "",
  });

  const [newStatus, { isLoading: newStatusIsLoading }] =
    useAdminChangeStatusMutation();

  const { data: restaurantData, isLoading: restauramtIsLoading } =
    useGetRestaurantQuery({
      searchText: "",
      id: "",
    });

  const userList = useMemo(() => {
    return userData?.data as IUserAdmin[];
  }, [userData?.data]);

  const restaurantList = useMemo(() => {
    return restaurantData?.data as IRestaurant[];
  }, [restaurantData?.data]);

  const userMap = useMemo(() => {
    const map = new Map();
    userList?.forEach((category) => {
      map.set(category.id, `${category.user_role_name}`);
    });
    return map;
  }, [userList]);

  const branchMap = useMemo(() => {
    const map = new Map();
    restaurantList?.forEach((category) => {
      map.set(category.id, `${category.restaurantsName}`);
    });
    return map;
  }, [restaurantList]);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };
  const handleChangePageSentToManager = (event: unknown, newPage: number) => {
    setPageSentToManager(newPage);
  };

  const handleIsStatus = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValues = event.target.value;
    setSelectedProductIsAllStatus(selectedValues);
  };

  useEffect(() => {
    if (debouncedSearchQuery.length >= 2 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  useEffect(() => {
    if (
      debouncedSearchQuerySentToManager.length >= 2 ||
      debouncedSearchQuerySentToManager === ""
    ) {
      setCurrentSearchQuerySentToManager(debouncedSearchQuerySentToManager);
      refetch();
    }
  }, [debouncedSearchQuerySentToManager]);

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpenDialog = (coursing: IOrderList) => {
    setSelectedCoursing(coursing);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setSelectedCoursing(null);
    setOpenDialog(false);
  };

  const handleOpenDeletePopup = (coursing: IOrderList) => {
    setCoursingToDelete(coursing);
    setOpenDeleteCategory(true);
  };

  const handleCloseDeletePopup = () => {
    setCoursingToDelete(null);
    setOpenDeleteCategory(false);
  };

  const handleOpenStatusPopup = (coursing: IOrderList) => {
    setCoursingToStatus(coursing);
    setOpen(true);
  };

  const handleCloseStatusPopup = () => {
    setCoursingToStatus(null);
    setOpen(false);
  };

  const handleOpenDialogGenerate = (coursing: IOrderList) => {
    setCoursingToStatus2(coursing);
    setOpenOrderListDate(true);
  };

  const handleCloseDialogGenerate = () => {
    setCoursingToStatus2(null);
    setOpenOrderListDate(false);
  };

  const formik = useFormik({
    initialValues: {
      id: "",
      status: "",
    },
    onSubmit: async (values, { resetForm }) => {
      try {
        const temData = {
          id: coursingToStatus2?.id,
          status: values.status,
        };

        const addCompanyResponse = await newStatus(temData).unwrap();
        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          showMessage(addCompanyResponse.message);
          resetForm();
          setOpenOrderListDate(false);
          setCoursingToStatus2(null);
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  const [deleteCategory] = useDeleteOrderListHistoryMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory(id).unwrap();
      if (response.status) {
        showMessage(response.message);
        setOpenDeleteCategory(false);
      } else {
        showErrorMessage(response.message);
      }
    } catch (error) {
      showErrorMessage("Failed to delete the Order");
    }
  };

  const [changeStatus] = useChangeStatusOrderListSentToManagerMutation();
  const handleChangeStatus = async (id: string) => {
    try {
      const response = await changeStatus(id).unwrap();
      if (response.status) {
        showMessage(response.message);
        setOpen(false);
      } else {
        showErrorMessage(response.message);
      }
    } catch (error) {
      showErrorMessage("Failed to change status");
    }
  };

  const coursings: IOrderList[] = Array.isArray(data?.data)
    ? (data?.data as IOrderList[])
    : [];

  const SentToManagerList: IOrderList[] = Array.isArray(SentToManagerData?.data)
    ? (SentToManagerData?.data as IOrderList[])
    : [];

  const handleConfirm = () => {
    setOpen(false);
    navigate("/payroll/generate");
  };

  const handleAddProductClick = () => {
    navigate("/order/list/create");
  };

  const formValid = useMemo(() => {
    return formik.values.status !== "" && formik.values.status !== undefined;
  }, [formik]);

  return (
    <Grid container spacing={3}>
      {/* {userHasRight(Privileges.OrderListManagerApproved) && ( */}
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Card className={classes.card}>
          <Grid
            container
            justifyContent={"space-between"}
            spacing={5}
            sx={{ borderBottom: 2, padding: 2 }}
            className={classes.titleGrid}
          >
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Grid
                container
                spacing={1}
                justifyContent="flex-end"
                sx={{
                  display: "flex",
                  justifyContent: {
                    xs: "flex-start",
                    md: "flex-end",
                  },
                }}
              >
                <Grid item>
                  <TextField
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <CiSearch className={classes.searchWidgetIcon} />
                        </InputAdornment>
                      ),
                      classes: {
                        root: classes.formControlList,
                      },
                    }}
                    fullWidth
                    value={searchQuerySentToManager}
                    onChange={(e) =>
                      setSearchQuerySentToManager(e.target.value)
                    }
                    placeholder="Order List ID .."
                    size="small"
                    className={classes.searchTextField}
                  />
                </Grid>
                <Grid item>
                  <TextField
                    select
                    size="small"
                    sx={{ flexGrow: 1, width: "100%" }}
                    value={selectedIsAllStatus || "AllStatus"}
                    onChange={handleIsStatus}
                    InputLabelProps={{ shrink: true }}
                    InputProps={{
                      classes: {
                        root: classes.formControlListStatus,
                      },
                    }}
                    className={classes.searchTextField34}
                  >
                    <MenuItem value={"AllStatus"}>All Status</MenuItem>
                    {Object.entries(OrderListStatusList).map(
                      ([key, value], index) => (
                        <MenuItem key={index} value={value}>
                          {convertStatus2(key)}
                        </MenuItem>
                      )
                    )}
                  </TextField>
                </Grid>
                <Grid item>
                  <Button
                    // variant="contained"
                    className={classes.addNewButton}
                    onClick={handleAddProductClick}
                  >
                    Add New
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid>
            <TableContainer>
              <Table className={classes.table}>
                <TableHead className={classes.tableHeaderRow}>
                  <TableRow>
                    <TableCell className={classes.tablheader}>
                      <strong>Order ID</strong>
                    </TableCell>

                    <TableCell
                      className={classes.tablheader}
                      // sx={{ textAlign: "center" }}
                    >
                      <strong>Branch</strong>
                    </TableCell>

                    <TableCell
                      className={classes.tablheader}
                      // sx={{ textAlign: "center" }}
                    >
                      <strong>Create By</strong>
                    </TableCell>
                    <TableCell
                      className={classes.tablheader}
                      // sx={{ textAlign: "center" }}
                    >
                      <strong>Status</strong>
                    </TableCell>

                    <TableCell
                      className={classes.tablheader}
                      sx={{ textAlign: "right" }}
                    >
                      <strong>Actions</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {SentToManagerIsLoading || userIsLoading ? (
                    <TableRow>
                      <TableCell colSpan={20} align="center">
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          height="10vh"
                        >
                          <CircularProgress />
                        </Box>
                      </TableCell>
                    </TableRow>
                  ) : SentToManagerIsError || SentToManagerList.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={20} align="center">
                        {isError ? "Error fetching data" : "No data available"}
                      </TableCell>
                    </TableRow>
                  ) : (
                    SentToManagerList.slice(
                      pageSentToManager * rowsPerPageSentToManager,
                      pageSentToManager * rowsPerPageSentToManager +
                        rowsPerPageSentToManager
                    ).map((row: IOrderList, index) => (
                      <TableRow key={row.id} className={classes.tableRowHover}>
                        <TableCell
                          component="th"
                          scope="row"
                          className={classes.tablCell}
                        >
                          <Typography
                            onClick={() => {
                              if (
                                row.orderListStatus === "OrderListCreated" ||
                                row.orderListStatus === "SentToManager" ||
                                row.orderListStatus === "ManagerApproved" ||
                                row.orderListStatus === "Rejected"
                              ) {
                                navigate(`/order/list/view/${row.id}`);
                              } else if (
                                row.orderListStatus === "UpdatedPrice" ||
                                row.orderListStatus === "Processed" ||
                                row.orderListStatus === "ReceiptUpdated"
                              ) {
                                navigate(
                                  `/order/list/set/price/list/${row.id}`
                                );
                              }
                            }}
                            sx={{
                              cursor: "pointer",
                            }}
                          >
                            {row.orderListId}
                          </Typography>
                        </TableCell>
                        <TableCell
                          scope="row"
                          className={classes.tablCell}
                          // sx={{ textAlign: "center" }}
                        >
                          {branchMap.get(row.restaurantsId) || ""}
                        </TableCell>
                        <TableCell
                          scope="row"
                          className={classes.tablCell}
                          // sx={{ textAlign: "center" }}
                        >
                          <Typography>
                            {userMap.get(row.created_by) || ""}
                          </Typography>
                          <Typography>
                            {dayjs(row.created_at).format(
                              "MMM D, YYYY hh:mm A"
                            )}
                          </Typography>
                        </TableCell>
                        <TableCell
                          scope="row"
                          className={classes.tablCell}
                          // sx={{ textAlign: "center" }}
                        >
                          <Grid
                            container
                            spacing={1}
                            //  justifyContent={"center"}
                          >
                            <Grid
                              item
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                              sx={{
                                display: "flex",
                                // justifyContent: "center",
                              }}
                            >
                              <Box
                                className={
                                  row.orderListStatus === "OrderListCreated"
                                    ? classes.statusCreated
                                    : row.orderListStatus === "SentToManager"
                                    ? classes.statusSent
                                    : row.orderListStatus === "ManagerApproved"
                                    ? classes.statusApproved
                                    : row.orderListStatus === "UpdatedPrice"
                                    ? classes.statusUpdated
                                    : row.orderListStatus === "ManagerConfirmed"
                                    ? classes.statusConfirmed
                                    : row.orderListStatus === "Processed"
                                    ? classes.statusProcessed
                                    : row.orderListStatus === "Completed"
                                    ? classes.statusCompleted
                                    : row.orderListStatus === "ReceiptUpdated"
                                    ? classes.statusCompleted
                                    : row.orderListStatus === "Rejected"
                                    ? classes.statusRejected
                                    : ""
                                }
                                // sx={{
                                //   cursor: "pointer",
                                // }}
                                // onClick={() => {
                                //   if (
                                //     row.orderListStatus === "OrderListCreated"
                                //   ) {
                                //     handleOpenStatusPopup(row);
                                //   } else {
                                //     handleOpenDialogGenerate(row);
                                //   }
                                // }}
                              >
                                {convertStatus(row.orderListStatus)}
                              </Box>
                            </Grid>
                          </Grid>
                        </TableCell>

                        <TableCell scope="row" className={classes.tablCell}>
                          <Grid
                            container
                            spacing={1}
                            sx={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <>
                              <Grid item>
                                <Button
                                  className={classes.viewButtonList}
                                  onClick={() => {
                                    if (
                                      row.orderListStatus ===
                                        "OrderListCreated" ||
                                      row.orderListStatus === "SentToManager" ||
                                      row.orderListStatus ===
                                        "ManagerApproved" ||
                                      row.orderListStatus === "Rejected"
                                    ) {
                                      navigate(`/order/list/view/${row.id}`);
                                    } else if (
                                      row.orderListStatus === "UpdatedPrice" ||
                                      row.orderListStatus === "Processed" ||
                                      row.orderListStatus === "ReceiptUpdated"
                                    ) {
                                      navigate(
                                        `/order/list/set/price/list/${row.id}`
                                      );
                                    }
                                  }}
                                >
                                  <VisibilitySharpIcon
                                    className={classes.viewListIcon}
                                  />
                                </Button>
                              </Grid>
                              {(row.orderListStatus === "OrderListCreated" ||
                                row.orderListStatus === "SentToManager" ||
                                row.orderListStatus === "ManagerApproved" ||
                                row.orderListStatus === "UpdatedPrice") && (
                                <Grid item>
                                  <Button
                                    // variant="contained"
                                    className={classes.editButtonList}
                                    // onClick={() =>
                                    //   navigate(`/order/list/edit/${row.id}`)
                                    // }
                                    onClick={() => {
                                      if (
                                        row.orderListStatus ===
                                        "ManagerApproved"
                                      ) {
                                        navigate(
                                          `/order/list/price/admin/edit/${row.id}`
                                        );
                                      } else if (
                                        row.orderListStatus ===
                                          "SentToManager" ||
                                        row.orderListStatus ===
                                          "OrderListCreated"
                                      ) {
                                        navigate(`/order/list/edit/${row.id}`);
                                      } else if (
                                        row.orderListStatus === "UpdatedPrice"
                                      ) {
                                        navigate(
                                          `/order/list/set/price/edit/${row.id}`
                                        );
                                      }
                                    }}
                                  >
                                    {row.orderListStatus ===
                                    "ManagerApproved" ? (
                                      <ChecklistRtlRoundedIcon
                                        className={classes.editListIcon}
                                      />
                                    ) : (
                                      <EditSharpIcon
                                        className={classes.editListIcon}
                                      />
                                    )}
                                  </Button>
                                </Grid>
                              )}
                              {row.orderListStatus !== "ReceiptUpdated" &&
                                row.orderListStatus !== "Processed" && (
                                  <Grid item>
                                    <Button
                                      // variant="contained"
                                      className={classes.deleteButtonList}
                                      onClick={() => handleOpenDeletePopup(row)}
                                    >
                                      <DeleteOutlineSharpIcon
                                        className={classes.deleteListIcon}
                                      />
                                    </Button>
                                  </Grid>
                                )}
                            </>
                          </Grid>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
              <Grid
                spacing={5}
                p={"18px"}
                py={4}
                justifyContent={"end"}
                container
                textAlign={"center"}
                alignContent={"center"}
                alignItems={"center"}
              >
                <Grid
                  sx={{
                    textAlign: "end",
                    justifyContent: "flex-end",
                    alignItems: "flex-end",
                  }}
                >
                  <Pagination
                    count={SentToManagerList.length}
                    page={pageSentToManager}
                    rowsPerPage={rowsPerPageSentToManager}
                    onPageChange={handleChangePageSentToManager}
                  />
                </Grid>
              </Grid>
            </TableContainer>
            {coursingToDelete && (
              <DeletePopup
                open={openDeleteCategory}
                handleCloseDelete={handleCloseDeletePopup}
                onConfirm={async () => {
                  await handleDelete(coursingToDelete.id.toString());
                }}
                title="Delete Order"
                content={`Are you sure you want to delete "${coursingToDelete.orderListId}"?`}
              />
            )}

            {coursingToStatus && (
              <StatusPopup
                open={open}
                handleCloseDelete={handleCloseStatusPopup}
                onConfirm={async () => {
                  await handleChangeStatus(coursingToStatus.id.toString());
                }}
                title="Confirm Status Change"
                content={`Are you sure you want to change the status to "Manager Approval Pending"? 
            Once updated, this action cannot be undone. 
            Order ID: ${coursingToStatus.orderListId}`}
              />
            )}
          </Grid>
        </Card>
      </Grid>
      {/* )} */}
      {/* <Grid item lg={12} md={12} sm={12} xs={12}>
        <Card className={classes.card}>
          <Grid
            container
            justifyContent={"space-between"}
            spacing={5}
            sx={{ borderBottom: 2, padding: 2 }}
            className={classes.titleGrid}
          >
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Grid
                container
                spacing={1}
                justifyContent="flex-end"
                sx={{ display: "flex" }}
              >
                <Grid item>
                  <TextField
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <CiSearch className={classes.searchWidgetIcon} />
                        </InputAdornment>
                      ),
                      classes: {
                        root: classes.formControlList,
                      },
                    }}
                    fullWidth
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Order List ID .."
                    size="small"
                    className={classes.searchTextField}
                  />
                </Grid>
                <Grid item>
                  <Button
                    // variant="contained"
                    className={classes.addNewButton}
                    onClick={handleAddProductClick}
                  >
                    Add New
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid>
            <TableContainer>
              <Table className={classes.table}>
                <TableHead className={classes.tableHeaderRow}>
                  <TableRow>
                    <TableCell className={classes.tablheader}>
                      <strong>Order ID</strong>
                    </TableCell>

                    <TableCell
                      className={classes.tablheader}
                      sx={{ textAlign: "center" }}
                    >
                      <strong>Create By</strong>
                    </TableCell>
                    <TableCell
                      className={classes.tablheader}
                      sx={{ textAlign: "center" }}
                    >
                      <strong>Status</strong>
                    </TableCell>

                    <TableCell
                      className={classes.tablheader}
                      sx={{ textAlign: "right" }}
                    >
                      <strong>Actions</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {isLoading || userIsLoading ? (
                    <TableRow>
                      <TableCell colSpan={20} align="center">
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          height="10vh"
                        >
                          <CircularProgress />
                        </Box>
                      </TableCell>
                    </TableRow>
                  ) : isError || coursings.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={20} align="center">
                        {isError ? "Error fetching data" : "No data available"}
                      </TableCell>
                    </TableRow>
                  ) : (
                    coursings
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row: IOrderList, index) => (
                        <TableRow
                          key={row.id}
                          className={classes.tableRowHover}
                        >
                          <TableCell
                            component="th"
                            scope="row"
                            className={classes.tablCell}
                          >
                            <Typography
                              onClick={() =>
                                navigate(`/order/list/view/${row.id}`)
                              }
                              sx={{
                                cursor: "pointer",
                              }}
                            >
                              {row.orderListId}
                            </Typography>
                          </TableCell>
                          <TableCell
                            scope="row"
                            className={classes.tablCell}
                            sx={{ textAlign: "center" }}
                          >
                            <Typography>
                              {userMap.get(row.created_by) || ""}
                            </Typography>
                            <Typography>
                              {dayjs(row.created_at).format(
                                "YYYY-MM-D hh:mm A"
                              )}
                            </Typography>
                          </TableCell>
                          <TableCell
                            scope="row"
                            className={classes.tablCell}
                            sx={{ textAlign: "center" }}
                          >
                            <Grid
                              container
                              spacing={1}
                              justifyContent={"center"}
                            >
                              <Grid
                                item
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <Box
                                  className={
                                    row.orderListStatus === "OrderListCreated"
                                      ? classes.statusCreated
                                      : row.orderListStatus === "SentToManager"
                                      ? classes.statusSent
                                      : row.orderListStatus ===
                                        "ManagerApproved"
                                      ? classes.statusApproved
                                      : row.orderListStatus === "UpdatedPrice"
                                      ? classes.statusUpdated
                                      : row.orderListStatus ===
                                        "ManagerConfirmed"
                                      ? classes.statusConfirmed
                                      : row.orderListStatus === "Processed"
                                      ? classes.statusProcessed
                                      : row.orderListStatus === "Completed"
                                      ? classes.statusCompleted
                                      : row.orderListStatus === "Rejected"
                                      ? classes.statusRejected
                                      : ""
                                  }
                                  sx={{
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleOpenStatusPopup(row)}
                                >
                                  {convertStatus(row.orderListStatus)}
                                </Box>
                              </Grid>
                            </Grid>
                          </TableCell>

                          <TableCell scope="row" className={classes.tablCell}>
                            <Grid
                              container
                              spacing={1}
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              {row.orderListStatus === "OrderListCreated" && (
                                <>
                                  <Grid item>
                                    <Button
                                      // variant="contained"
                                      className={classes.viewButtonList}
                                      onClick={() =>
                                        navigate(`/order/list/view/${row.id}`)
                                      }
                                    >
                                      <VisibilitySharpIcon
                                        className={classes.viewListIcon}
                                      />
                                    </Button>
                                  </Grid>
                                  <Grid item>
                                    <Button
                                      // variant="contained"
                                      className={classes.editButtonList}
                                      onClick={() =>
                                        navigate(`/order/list/edit/${row.id}`)
                                      }
                                    >
                                      <EditSharpIcon
                                        className={classes.editListIcon}
                                      />
                                    </Button>
                                  </Grid>
                                  <Grid item>
                                    <Button
                                      // variant="contained"
                                      className={classes.deleteButtonList}
                                      onClick={() => handleOpenDeletePopup(row)}
                                    >
                                      <DeleteOutlineSharpIcon
                                        className={classes.deleteListIcon}
                                      />
                                    </Button>
                                  </Grid>
                                </>
                              )}
                            </Grid>
                          </TableCell>
                        </TableRow>
                      ))
                  )}
                </TableBody>
              </Table>
              <Grid
                spacing={5}
                p={"18px"}
                py={4}
                justifyContent={"end"}
                container
                textAlign={"center"}
                alignContent={"center"}
                alignItems={"center"}
              >
                <Grid
                  sx={{
                    textAlign: "end",
                    justifyContent: "flex-end",
                    alignItems: "flex-end",
                  }}
                >
                  <Pagination
                    count={coursings.length}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    onPageChange={handleChangePage}
                  />
                </Grid>
              </Grid>
            </TableContainer>
            {coursingToDelete && (
              <DeletePopup
                open={openDeleteCategory}
                handleCloseDelete={handleCloseDeletePopup}
                onConfirm={async () => {
                  await handleDelete(coursingToDelete.id.toString());
                }}
                title="Delete Order"
                content={`Are you sure you want to delete "${coursingToDelete.orderListId}"?`}
              />
            )}

            {coursingToStatus && (
              <StatusPopup
                open={open}
                handleCloseDelete={handleCloseStatusPopup}
                onConfirm={async () => {
                  await handleChangeStatus(coursingToStatus.id.toString());
                }}
                title="Confirm Status Change"
                content={`Are you sure you want to change the status to "Manager Approval Pending"? 
                  Once updated, this action cannot be undone. 
                  Order ID: ${coursingToStatus.orderListId}`}
              />
            )}
          </Grid>
        </Card>
      </Grid> */}

      <Dialog
        open={openOrderListDate}
        onClose={handleCloseDialogGenerate}
        sx={{ padding: 5, minWidth: 450 }}
      >
        <Grid className={isMobileRes ? classes.DialogMobile : classes.Dialog}>
          <form onSubmit={formik.handleSubmit}>
            <Grid
              container
              justifyContent={"space-between"}
              spacing={5}
              sx={{ borderBottom: 2, padding: 2 }}
              className={classes.titleGrid}
            >
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                pt={2}
                alignContent={"center"}
              >
                <Typography className={classes.cardTitle}>
                  Confirm Action
                </Typography>
              </Grid>
            </Grid>
            <DialogContent>
              <DialogContentText sx={{ pt: 3 }}>Status</DialogContentText>
              <Grid container alignItems="center">
                <Grid item lg={12} md={12} sm={12} xs={12} pt={1}>
                  <TextField
                    select
                    size="small"
                    className={classes.textField}
                    SelectProps={{
                      native: false,
                    }}
                    defaultValue=""
                    InputLabelProps={{ shrink: true }}
                    {...formik.getFieldProps("status")}
                  >
                    <MenuItem value="" disabled>
                      Select some option
                    </MenuItem>

                    {Object.entries(OrderListStatus).map(
                      ([key, value], index) => (
                        <MenuItem key={index} value={value}>
                          {convertStatus2(key)}
                        </MenuItem>
                      )
                    )}
                  </TextField>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button
                variant="outlined"
                startIcon={<CloseIcon />}
                className={classes.addButton}
                onClick={handleCloseDialogGenerate}
              >
                Cancel
              </Button>
              <Box m={0.5}></Box>

              <Button
                variant="contained"
                startIcon={<CheckCircleOutlineIcon />}
                className={classes.addButton}
                onClick={() => formik.handleSubmit()}
                disabled={!formValid || newStatusIsLoading}
              >
                Confirm
              </Button>
            </DialogActions>
          </form>
        </Grid>
      </Dialog>
    </Grid>
  );
};

export default Index;
